module.exports = __webpack_public_path__ + "img/img_quesheng@2x.b9ca4505.png";